import { EventEmitter } from "events";
class EnterFrame extends EventEmitter {
  constructor() {
    super();
    this.hoge = 1;
    this.request();
  }
  request(){
    requestAnimationFrame(()=>{
      this.update();
    });
  }
  update() {
    this.emit("update");
    this.request();
  }
}

export const EnterFrameI = new EnterFrame();
